class FootnoteManager {
  constructor() {
    this.footnotes = []
    this.count = this.count.bind(this)
    this.add = this.add.bind(this)
    this.getFootnotes = this.getFootnotes.bind(this)
    this.reset = this.reset.bind(this)
  }

  count() {
    return this.footnotes.length
  }

  add(footnoteContext) {
    let id

    this.footnotes.forEach((footnote) => {
      if (JSON.stringify(footnote) === JSON.stringify({ id: footnote.id, ...footnoteContext })) {
        id = footnote.id
      }
    })

    if (!id) {
      id = `${this.count() + 1}`
      this.footnotes.push({ id, ...footnoteContext })
    }

    return id
  }

  getFootnotes() {
    return [...this.footnotes]
  }

  reset() {
    this.footnotes = []
  }
}

const footnoteState = new FootnoteManager()
export default footnoteState
